var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"padding":"50px"}},[_c('b-skeleton',{attrs:{"animation":"wave","height":"15px"}}),_c('div',[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }